var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
import { Pager } from 'react-bootstrap';

import StudentsTable from './StudentsTable';
var StudentRes = require('../../resources/student');

var $ = require('jquery');
import notification from '../Modal/notification';

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const ITEM_LIMIT = 20;
var Students = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  onSortChange: function(newSort) {
    this.setState({
      sort: newSort,
      studentsData: [],
      isLoading: true,
      currentPager: 1,
    }, () => {
      this.retrieveStudents();
    });
  },
  getInitialState: function() {
    return {
      searchStudentName: '',
      statusMode: [],
      currentMode: {},
      studentsData: [],
      isLoading: true,
      // conceptsMap: null,
      currentPager: 1,
      sort: 'firstName',
      ifViewingFromClass: false
    };
  },
  handleChangeData: function(e) {
    // var update = {};
    // update[field] = e.target.value;
    // this.setState(update);
    // var searchName = this.state.searchStudentName;
    this.setState({
      searchStudentName: e.target.value,
      studentsData: [],
      isLoading: true,
      currentPager: 1,
      sort: 'firstName'
    }, () => {
      this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
    });
  },
  submit: function() {
    // var _this = this;
    // var oldPassword = _this.state.currentPassword;
    // var newPassword = _this.state.newPassword;
    // var confirmPassword = _this.state.confirmPassword;
    // if (!oldPassword || !newPassword || !confirmPassword) return alert('Please input all fields');
    // if (newPassword !== confirmPassword) return alert('New password not match');
    // _this.setState({
    //   isLoading: true
    // })
    // Auth.changePassword({
    //   "oldPassword": oldPassword,
    //   "newPassword": newPassword
    // }, function(err, res) {
    //   _this.setState({
    //     isLoading: false
    //   })
    //   if (err && err.response && err.response.text === 'WRONG_PASSWORD') return alert('Wrong password');
    //   if (err) return alert('Error occurred. Please try again later');
    //   alert('Change password success');
    // })
  },
  componentDidMount: function() {

    var _this = this;
    var statusMode = this.state.statusMode;
    statusMode = STUDENT_STATUSES;
    var currentUser = Auth.getCurrentUser();
    // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    // if (currentUser.role === 'admin') {
    //   statusMode = ADMIN_STATUSES;
    // } else  {
    //   statusMode = TEACHER_STATUSES;
    // }
    var currentMode = statusMode[0];
    if (this.props.location.query.mode) {
      var mode = this.props.location.query.mode,
          mappedMode = statusMode.filter((value) => {
            return value.code === mode
          })[0];
      if (mappedMode) currentMode = mappedMode;
    }
    this.setState({
      isLoading: true,
      statusMode: statusMode,
      currentMode: currentMode
    }, function() {
      // var count = statusMode.length;
      // for (var i = 0; i < statusMode.length; i++) {
      //   this.countCollectionInMode(statusMode[i], function() {
      //     count--;
      //     if (count <= 0) _this.forceUpdate();
      //   });
      // }
      this.retrieveStudents();
    });
  },
  unlinkStudent: function(studentID,callback) {
    
    if (window.confirm('Are you sure you wish to unlink this student?')) {
      
      var currentUser = Auth.getCurrentUser();
      var teacherID = currentUser._id; //current user (teacher/admin's id)

      // var _id = _this.state._id;
      // if (_this.state._id) { _id = _this.state._id; }

      var passData = {
        studentID: studentID,
        teacherID:teacherID
      };

    // alert("ABOUT TO DELTE ID: " + _id);
      $("body, html").addClass("heavy-load");
      StudentRes.unlinkStudent(passData, (err, res) => {
          $("body, html").removeClass("heavy-load");
          if (callback) return callback(err, res);
          if (err) {
              return notification.open({
                  message: 'Error',
                  description: 'Cannot unlink student. Please try again'
              });
          }
          // this.setState({
          //     studentClass: res
          // }, () => {
          notification.open({
              message: 'Success',
              description: "Student has been unlinked!"
          });
          this.retrieveStudents();
              // browserHistory.push('/students');
              // if (_this.state.isCreateNew) browserHistory.push('/students');
          // })
      })
    }
  },
  deleteStudent: function(_id,callback) {
    
    if (window.confirm('Are you sure you wish to delete this student?')) {
      
    // alert("ABOUT TO DELTE ID: " + _id);
      $("body, html").addClass("heavy-load");
      StudentRes.deleteStudent(_id, (err, res) => {
          $("body, html").removeClass("heavy-load");
          if (callback) return callback(err, res);
          if (err) {
              return notification.open({
                  message: 'Error',
                  description: 'Cannot delete student. Please try again'
              });
          }
          // this.setState({
          //     studentClass: res
          // }, () => {
          notification.open({
              message: 'Success',
              description: "Student has been deleted!"
          });
          this.retrieveStudents();
              // browserHistory.push('/students');
              // if (_this.state.isCreateNew) browserHistory.push('/students');
          // })
      })
    }
  },
  retrieveStudents: function(fName,lName,callback) {

    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    options.skip = ITEM_LIMIT * (currentPager - 1);
    options.limit = ITEM_LIMIT;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};
    // options.conditions.status = {
    //   "$in": this.state.currentMode.value
    // }
    // if (!this.state.currentMode.canApplyAdminRole) {
    //   options.conditions.creator = Auth.getCurrentUser()._id;
    // }
    // if (this.state.currentMode.include) {
    //   options.include = this.state.currentMode.include;
    //   options.includeConditions = includeConditions[options.include];
    // }
          // console.log("state of mdoe is " + this.state.currentMode.cols);
          
          //check to see if current user is teacher or admin. if teacher, pass in this teacher's id to ensure that
          //he or she can only retrieve the students that he or she created
    var currentUser = Auth.getCurrentUser();
    if (currentUser.status && currentUser.status.indexOf('teacher') >= 0) {

      options.conditions.teacherID = currentUser._id;
    
    } else if (currentUser.status && currentUser.status.indexOf('admin') >= 0) {

      options.conditions.ifAdmin = 'true';
    }

    var firstN = '';
    var lastN = '';
    if (fName) { firstN = fName; }
    if (lName) { lastN = lName; }

    options.conditions.sort = this.state.sort || "dateCreated";
    options.conditions.status = 'student';
    options.conditions.firstName = firstN;
    options.conditions.lastName = lastN;
    StudentRes.retrieveStudents(options, function(err, res) {
      // console.log("BEFORE DON sdfdsfsE!!");
      // if (callback) return callback(err, res);
      // console.log("BEFORE DONE!!");
      _this.setState({
        isLoading: false,
        studentsData: (!err && res) ? res: [{}]
      }, () => {

        var sData = _this.state.studentsData;
        for (var i = 0; i < sData.length; i++) {

          var thisData = sData[i];
          var dDate = thisData['lastActivityDate'];
          var processDate = new Date(dDate);
          var dateToDisplay = processDate.toDateString();
          if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
          thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
        }

        _this.setState({
          studentsData: sData
        });
        // console.log("DONE!!!");
      }
      // , function() {
        // _this.retrieveCollectionQuestionStat(function() {
          // if (_this.state.currentMode.showReviewStat) {
          //   var collections = _this.state.collectionData;
          //   for (var i = 0; i < collections.length; i++) {
          //     _this.retrieveCollectionTaskStat(collections[i]);
          //   }
          // }
        // });
        // return callback(err, res);
      // }
      );
    })
  },
  navigatePager: function(dir) {
    var currentPager = this.state.currentPager,
              _this  =  this;
    currentPager += dir;
    _this.setState({
      currentPager: currentPager,
      isLoading: true
    }, function() {
      this.retrieveStudents(this.state.searchStudentName,this.state.searchStudentName);
      // this.retrieveStudents(function(err, res) {
      // })
    })
  },
  render: function() {
    
    var _this = this;
    var currentUser = Auth.getCurrentUser(),
        isAdmin = currentUser && currentUser.status && currentUser.status.indexOf('admin') >= 0;

    return (
        <div className="students">
            <h3> Student Management </h3>
            <div className="content-toolbar">
            <div className="btn-holder">
              {
                isAdmin && 
                  <Link to={"student/new"}>
                    <button className="btn btn-success">
                        <i className="fa fa-plus" style={{"paddingRight": "5px"}}></i>
                        <span>New Student</span>
                    </button>
                  </Link>
              }
                &nbsp;&nbsp;
                <Link to={"student/link"}>
                <button className="btn btn-success">
                    <i className="fa fa-plus" style={{"paddingRight": "5px"}}></i>
                    <span>Link student with code</span>
                </button>
                </Link>
            </div>
            </div>
            <div className="row">
            
              <div className="col col-md-10">
                  <input type="text" className="form-control mark-input searchStudentName" onChange={_this.handleChangeData} value={_this.state.searchStudentName} placeholder='Enter student name to search for'/>
              </div>
            </div>
            <hr />
            {
              
              (_this.state.studentsData.length > 0 && !_this.state.isLoading) &&
              
              <StudentsTable
                data={this.state.studentsData}
                mode={this.state.currentMode}
                sort={this.state.sort}
                deleteStudent={this.deleteStudent}
                unlinkStudent={this.unlinkStudent}
                //onDelete={this.deleteCollection}
                onSortChange={this.onSortChange}
                ifViewingFromClass={this.state.ifViewingFromClass}
                //onUpdateSingleCollection={this.updateSingleCollection}
              />
            }
            {
            _this.state.isLoading &&
            <CircularProgress />
            }
            <Pager>
              {
                _this.state.currentPager > 1 &&
                <Pager.Item
                  onClick={_this.navigatePager.bind(_this, -1)}
                  disabled={_this.state.currentPager === 1}
                >
                  Previous
                </Pager.Item>
              }
              {' '}
              {
                _this.state.studentsData.length >= ITEM_LIMIT &&
                <Pager.Item
                  onClick={_this.navigatePager.bind(_this, 1)}
                  disabled={_this.state.studentsData.length < ITEM_LIMIT}
                >
                  Next
                </Pager.Item>
              }
            </Pager>
        </div>
    );
  }

});

module.exports = Students;



/** WEBPACK FOOTER **
 ** ./src/components/Students/students.js
 **/